import React, { useEffect, useState } from "react";
import { Field, useFormikContext } from "formik";
import { FormGroup, Label } from "reactstrap";
import styles from "./Resource.module.scss";
import { useSelector } from "react-redux";
import ReactSelect from "../common/Form/ReactSelect";

function UserInfo() {
  const [options, setOptions] = useState([]);
  const { errors, touched } = useFormikContext();
  const user = useSelector((state) => state.authentication.user);
  const enumData = useSelector((state) => state.resources.enumData);
  useEffect(() => {
    if (enumData && enumData?.role) {
      let op = [];
      for (const [key, value] of Object.entries(enumData?.role)) {
        op.push({ value: key, label: value });
      }
      setOptions(op);
    }
  }, [enumData]);

  return (
    <div>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>User Role</Label>
        <Field
          name="role"
          id="role"
          placeholder="Select Role"
          isMulti={false}
          component={ReactSelect}
          options={options}
          autocomplete="off"
        />
         {errors?.role || touched?.role ? (
          <div className={styles.formError}>{errors.role}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Email</Label>
        <Field maxlength="30" name="email" id="email" className="form-control" />
        {errors?.email || touched?.email ? (
          <div className={styles.formError}>{errors.email}</div>
        ) : null}
      </FormGroup>
    </div>
  );
}

export default UserInfo;
